export const COUNT_PROFILE_GROUPS_START =
  'COUNT_PROFILE_GROUPS_START';
export const COUNT_PROFILE_GROUPS_FAILED =
  'COUNT_PROFILE_GROUPS_FAILED';
export const COUNT_PROFILE_GROUPS_SUCCESS =
  'COUNT_PROFILE_GROUPS_SUCCESS';
